/** Interfaces */
import { BydCleanInstance } from '@sixense/byd-clean-instance';
import { DsPinStatusInterface } from '../interfaces/ds-pin-status.interface';

@BydCleanInstance
export class DsPinStatus implements DsPinStatusInterface {
  /**
   * The id of pin status
   */
  readonly id: number;

  /**
   * The customized label
   */
  public label?: string;

  /**
   * The status color
   */
  public color?: string;

  /** The default label */
  public defaultLabel?: string;

  /**
   * Creates an instance of DsPinStatus.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsPinStatusInterface) {
    this.id = jsonData.id;
    this.color = jsonData?.color;
    this.label = jsonData?.label;
    this.defaultLabel = jsonData?.defaultLabel;
  }
}
